import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

/**
 * for this page
 */
import Tab from './tab';

class YdjkTable extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        isOpen: PropTypes.bool,
    };

    /**
     * 渲染组件
     */
    render() {
        const { isOpen } = this.props;
        const { title, tables } = this.props.content;

        return (
            <div className={styles.tab}>
                <div className={styles.title}>{title}</div>
                <div className={styles.box}>
                    {tables.map((item, index) => <Tab key={index} content={{ ...item, idx: index }} isOpen={isOpen} />)}
                </div>
            </div>
        );
    }
}

export default errorBoundary(YdjkTable);
